import { VBase } from "./VBase";
import VUtil from "../VUtils";

const defaultOptions = {
  text: "按钮",
  map: null,
  color: 0xffffff,
  opacity: 1.0,
  textSize: 0.03,
  textColor: 0x000000,
  width: 0.2,
  height: 0.1,
  radius: 0.01,
  outlineWidth: 0.001,
  font: "normal",
  align: "center",
  disabledColor: 0xc8c8c8,
  stateChangeImage: null,
  stateChangeColor: null,
};

/*
  使用案例

     const btn = this.uiLib.createBtn({
        width: 0.5,
        height: 0.2,
        textSize: 0.05,
        textColor: 0x00ffff,
        text: "确定",
        stateChangeColor: {
          normal: "#ffffff",
          hover: "#af3546",
          click: "#C8C8C8",
        },
      });
      btn.addEnabledEvent((obj, enabled) => {
        // 这里可以设置禁用按钮后让按钮颜色变浅或启用按钮后恢复按钮颜色
        console.log("设置了按钮的启用状态：" + obj.name + "  " + enabled);
      });
      btn.addClickEvent((obj) => {
        console.log("点击了按钮：" + obj.name + ",将禁用此按钮");
        btn.setEnabled(false);
      });
      btn.addHoverEnterEvent((obj) => {
        // 添加光标进入事件后将覆盖按钮默认的光标进入事件（放大按钮）
        console.log("光标进入按钮：" + obj.name);
      });
      btn.addHoverExitEvent((obj) => {
        console.log("光标离开按钮：" + obj.name);
      });
      this.uiLib.addUIToScene(btn);


*/
export class VButton extends VBase {
  /**
   * 按钮默认的光标进入事件是方法按钮，可添加光标进入事件覆盖
   * options:
   * {
   *      priority: 优先级，默认为0，值越小越靠前
   *      renderOrder: 渲染顺序，默认为99999
   *      text: 按钮文字内容，默认为"按钮"
   *      map: 按钮背景贴图，不是贴图地址，默认为null
   *      color: 按钮颜色。默认为 0xffffff
   *      opacity: 1,按钮背景透明度，默认为1
   *      textSize: 文字大小，默认为 0.03
   *      textColor: 文字颜色，默认为 0x000000
   *      width: 按钮宽度，默认为 0.2
   *      height: 按钮高度，默认为 0.1
   *      radius: 圆角半径，设为0则是矩形，默认为0.01
   *      font: 字体正常或粗体，"normal"-正常  "bold"-粗体 ，默认为"normal"
   *      outlineWidth: 文字描边宽度，默认为 0.001
   *      disabledColor: ui对象禁用颜色，默认为 0xC8C8C8
   *      stateChangeImage: 按钮状态改变时的贴图对象，可以包含3个状态（"normal","hover","click"）也可以只设置其中某些状态,默认为null
   *      stateChangeColor: 按钮状态改变时的颜色对象，可以包含3个状态（"normal","hover","click"）也可以只设置其中某些状态,默认为null
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      priority: options.priority !== undefined ? options.priority : 0,
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 99999,
      text: options.text !== undefined ? options.text : defaultOptions.text,
      map: options.map ? options.map : defaultOptions.map,
      color: options.color !== undefined ? options.color : defaultOptions.color,

      opacity:
        options.opacity !== undefined
          ? options.opacity
          : defaultOptions.opacity,
      textSize: options.textSize ? options.textSize : defaultOptions.textSize,
      align: options.align ? options.align : defaultOptions.align,
      textColor:
        options.textColor !== undefined
          ? options.textColor
          : defaultOptions.textColor,
      width: options.width !== undefined ? options.width : defaultOptions.width,
      height:
        options.height !== undefined ? options.height : defaultOptions.height,
      radius:
        options.radius !== undefined ? options.radius : defaultOptions.radius,
      outlineWidth:
        options.outlineWidth !== undefined
          ? options.outlineWidth
          : defaultOptions.outlineWidth,
      font: options.font ? options.font : defaultOptions.font,
      onHoverEnter: options.onHoverEnter ? options.onHoverEnter : null,
      onHoverExit: options.onHoverExit ? options.onHoverExit : null,
      onClick: options.onClick ? options.onClick : null,
      disabledColor:
        options.disabledColor !== undefined
          ? options.disabledColor
          : defaultOptions.disabledColor,
      enabledCb: options.enabledCb ? options.enabledCb : null,
      stateChangeImage: options.stateChangeImage
        ? options.stateChangeImage
        : null,
      stateChangeColor: options.stateChangeColor
        ? options.stateChangeColor
        : null,
    };

    super(tempOptions, vuiLib);

    this._vType = "VButton";

    this.name = "VButton_" + this._textProps.text;

    // 文字
    const text = VUtil.createText(
      this._textProps.text,
      this._textProps.textSize,
      this._textProps.textColor,
      this._textProps.font,
      null,
      this._textProps.outlineWidth,
      null,
      this._textProps.align
    );
    text.position.z = 0.001;
    text.renderOrder = this._baseProps.renderOrder;
    this.add(text);
  }

  onHoverEnter() {
    if (!this._baseProps.enabled) return;

    super.onHoverEnter();

    // 默认的按钮进入事件是放大
    if (this._eventProps.hoverEnterEvent.length <= 0) {
      this._vrHoverSrcScale = this.scale.clone();
      this.scale.multiplyScalar(1.1);
    }
  }

  onHoverExit() {
    //if (!this._baseProps || !this._baseProps.enabled) return;

    super.onHoverExit();

    // 默认的按钮退出事件是恢复大小
    if (this._eventProps && this._eventProps.hoverExitEvent.length <= 0) {
      if (this._vrHoverSrcScale) {
        this.scale.copy(this._vrHoverSrcScale);
        delete this._vrHoverSrcScale;
      }
    }
  }
}
